export const messages = {
  en: {
    communityRecommend: {
      queryCondition: 'Query Condition',
      selectRecommendType: 'Please select recommendation type',
      goods: 'Goods',
      housekeepingService: 'Housekeeping Service',
      external: 'External',
      communityRecommend: 'Community Recommendation',
      linkGoods: 'Link Goods',
      linkService: 'Link Service',
      linkExternal: 'Link External',
      logo: 'Logo',
      communityName: 'Community Name',
      shopName: 'Shop Name',
      recommendType: 'Recommendation Type',
      name: 'Name',
      price: 'Price',
      createTime: 'Create Time',
      add: 'Add',
      productName: 'Product Name',
      requiredProductName: 'Required, please enter product name',
      requiredPrice: 'Required, please enter price',
      accessUrl: 'Access URL',
      requiredAccessUrl: 'Required, please enter access URL',
      selectProduct: 'Select Product',
      selectShop: 'Please select shop',
      selectService: 'Please select service',
      requiredServiceName: 'Required, please enter service name',
      confirmDelete: 'Confirm to delete community recommendation?',
      logoRequired: 'Recommendation logo cannot be empty',
      productNameRequired: 'Product name cannot be empty',
      serviceNameRequired: 'Service name cannot be empty',
      priceRequired: 'Price cannot be empty',
      urlRequired: 'Access URL cannot be empty',
      max256Chars: 'Cannot exceed 256 characters',
      max512Chars: 'Cannot exceed 512 characters',
      max10Chars: 'Cannot exceed 10 characters',
      serviceName: 'Service Name'
    }
  },
  zh: {
    communityRecommend: {
      queryCondition: '查询条件',
      selectRecommendType: '请选择推荐类型',
      goods: '商品',
      housekeepingService: '家政服务',
      external: '站外',
      communityRecommend: '小区推荐',
      linkGoods: '关联商品',
      linkService: '关联服务',
      linkExternal: '关联站外',
      logo: 'logo',
      communityName: '小区名称',
      shopName: '店铺名称',
      recommendType: '推荐类型',
      name: '名称',
      price: '价格',
      createTime: '创建时间',
      add: '添加',
      productName: '商品名称',
      requiredProductName: '必填，请填写商品名称',
      requiredPrice: '必填，请填写价格',
      accessUrl: '访问地址',
      requiredAccessUrl: '必填，请填写访问地址',
      selectProduct: '选择商品',
      selectShop: '请选择店铺',
      selectService: '请选择家政服务',
      requiredServiceName: '必填，请填写服务名称',
      confirmDelete: '确定删除小区推荐',
      logoRequired: '推荐logo不能为空',
      productNameRequired: '商品名称不能为空',
      serviceNameRequired: '服务名称不能为空',
      priceRequired: '价格不能为空',
      urlRequired: '访问地址不能为空',
      max256Chars: '不能超过256个字符',
      max512Chars: '不能超过512个字符',
      max10Chars: '不能超过10个字符',
      serviceName: '服务名称'
    }
  }
}